/* TRIO – Panier tiroir */
(function () {
  'use strict';
  if (window.__trioCart) return;
  window.__trioCart = true;

  var root, panel, list, body, empty, foot, countEl, subEl, saveRow, saveEl, errEl, cfg, lastFocus;
  var FMT = '€{{amount_with_comma_separator}}';
  function money(c) {
    var v = (c / 100).toFixed(2), p = v.split('.');
    var th = function (x, s) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, s); };
    return FMT.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return th(String(Math.round(c / 100)), ',');
      if (k === 'amount_with_comma_separator') return th(p[0], '.') + ',' + p[1];
      if (k === 'amount_no_decimals_with_comma_separator') return th(String(Math.round(c / 100)), '.');
      if (k === 'amount_with_space_separator') return th(p[0], ' ') + ',' + p[1];
      return th(p[0], ',') + '.' + p[1];
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function model(t) { if (t.indexOf('™') > -1) { var m = t.split('™').pop().trim().toLowerCase(); return 'Trio ' + m.charAt(0).toUpperCase() + m.slice(1); } return t; }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }

  function setCount(n) {
    document.querySelectorAll('.tw-hd__cart b').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.tw-hd__cart').forEach(function (a) { a.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n > 1 ? 's' : '')); });
    countEl.textContent = n;
  }

  function mkey(t) { return t && t.indexOf('™') > -1 ? t.split('™').pop().trim().toUpperCase() : ''; }
  function giftIds() { var o = {}; Object.keys(cfg.gifts || {}).forEach(function (k) { o[cfg.gifts[k].id] = k; }); return o; }
  function isGift(it) { return it.product_type === 'free_gift' || giftIds()[it.variant_id] != null; }

  /* Un cadeau par poussette : on aligne les quantités des cadeaux sur celles des poussettes */
  function syncGifts(cart) {
    var g = cfg.gifts || {}, ids = giftIds(), want = {}, have = {}, upd = {}, diff = false;
    if (!Object.keys(g).length) return Promise.resolve(cart);
    Object.keys(ids).forEach(function (id) { want[id] = 0; have[id] = 0; });
    cart.items.forEach(function (it) {
      if (ids[it.variant_id] != null) { have[it.variant_id] += it.quantity; return; }
      if (it.product_type === 'free_gift') return;
      var k = mkey(it.product_title); if (g[k]) want[g[k].id] += it.quantity;
    });
    Object.keys(want).forEach(function (id) { if (want[id] !== have[id]) { upd[id] = want[id]; diff = true; } });
    if (!diff) return Promise.resolve(cart);
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .catch(function () { return cart; });
  }
  function show(cart) { return syncGifts(cart).then(function (c) { render(c); return c; }); }

  function giftRow(it, i) {
    var k = giftIds()[it.variant_id] || mkey(it.product_title), g = (cfg.gifts || {})[k] || {};
    var name = (g.count ? g.count + ' accessoires offerts' : 'Accessoires offerts');
    var cmp = g.compare || 0;
    return '<li class="tcd-item tcd-item--gift" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
      '<span class="tcd-item__img">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy" width="92" height="92">' : '') + '<i class="tcd-gift__tag" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1s3 1 5 1zm0 0c1.5-3 5-3.5 5-1s-3 1-5 1z"/></svg></i></span>' +
      '<div class="tcd-item__main"><div class="tcd-item__top"><div><span class="tcd-item__name">' + esc(name) + '</span>' +
      '<span class="tcd-item__var">Avec votre ' + esc(model(it.product_title)) + '</span></div></div>' +
      '<div class="tcd-item__bot"><span class="tcd-gift__qty">Inclus' + (it.quantity > 1 ? ' · × ' + it.quantity : '') + '</span>' +
      '<div class="tcd-item__price"><em class="tcd-free">Offert</em>' + (cmp ? '<s>' + money(cmp * it.quantity) + '</s>' : '') + '</div></div></div></li>';
  }

  function render(cart) {
    setCount(cart.item_count);
    var has = cart.item_count > 0;
    empty.hidden = has; list.hidden = !has; foot.hidden = !has;
    var save = 0, gifts = cart.items.filter(isGift), used = [], rows = [];
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      rows.push(it);
      gifts.forEach(function (g) { if (used.indexOf(g) < 0 && mkey(g.product_title) === mkey(it.product_title)) { rows.push(g); used.push(g); } });
    });
    gifts.forEach(function (g) { if (used.indexOf(g) < 0) rows.push(g); });
    list.innerHTML = rows.map(function (it, i) {
      if (isGift(it)) { var gk = (cfg.gifts || {})[giftIds()[it.variant_id] || mkey(it.product_title)]; if (gk && gk.compare) save += gk.compare * it.quantity; return giftRow(it, i); }
      var cmp = (cfg.compare && cfg.compare[it.variant_id]) || 0;
      if (cmp > it.final_price) save += (cmp - it.final_price) * it.quantity;
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<li class="tcd-item" style="--i:' + i + '" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '">' +
        '<a class="tcd-item__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy" width="92" height="92">' : '') + '</a>' +
        '<div class="tcd-item__main"><div class="tcd-item__top"><div><a class="tcd-item__name" href="' + esc(it.url) + '">' + esc(model(it.product_title)) + '</a>' +
        (vt ? '<span class="tcd-item__var">Coloris : ' + esc(vt) + '</span>' : '') + '</div>' +
        '<button type="button" class="tcd-item__rm" data-act="rm" aria-label="Retirer ' + esc(model(it.product_title)) + ' du panier"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12"/></svg></button></div>' +
        '<div class="tcd-item__bot"><div class="tcd-qty" role="group" aria-label="Quantité"><button type="button" data-act="minus" aria-label="Retirer un">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-act="plus" aria-label="Ajouter un">+</button></div>' +
        '<div class="tcd-item__price">' + money(it.final_line_price) + (cmp > it.final_price ? '<s>' + money(cmp * it.quantity) + '</s>' : '') + '</div></div></div></li>';
    }).join('');
    subEl.textContent = money(cart.total_price);
    saveRow.hidden = save <= 0; saveEl.textContent = money(save);
  }

  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(show); }

  function change(li, qty) {
    li.classList.add('is-busy'); errEl.hidden = true;
    var go = function () {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: li.dataset.key, quantity: qty }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(show).then(function (cart) { document.dispatchEvent(new CustomEvent('cart:changed', { detail: cart })); })
        .catch(function (e) { li.classList.remove('is-busy'); errEl.textContent = (e && e.description) || 'La mise à jour n’a pas fonctionné. Réessayez.'; errEl.hidden = false; });
    };
    if (qty === 0) { li.classList.add('is-out'); setTimeout(go, 250); } else go();
  }

  function focusables() { return panel.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]),input'); }
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tcd-lock');
    setTimeout(function () { var x = panel.querySelector('.tcd__x'); if (x) x.focus(); }, 60);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tcd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    root = document.querySelector('[data-tcd]'); if (!root) return;
    try { cfg = JSON.parse(root.querySelector('[data-tcd-json]').textContent); } catch (e) { cfg = {}; }
    if (cfg.moneyFormat) FMT = cfg.moneyFormat;
    panel = root.querySelector('.tcd__panel'); list = root.querySelector('.tcd__list'); body = root.querySelector('.tcd__body');
    empty = root.querySelector('.tcd__empty'); foot = root.querySelector('.tcd__foot'); countEl = root.querySelector('[data-tcd-count]');
    subEl = root.querySelector('[data-tcd-sub]'); saveRow = root.querySelector('[data-tcd-saverow]'); saveEl = root.querySelector('[data-tcd-save]'); errEl = root.querySelector('.tcd__err');

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.tw-hd__cart, a[href="/cart"][data-tcd-open]');
      if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); refresh(); open(); }
    });
    root.querySelectorAll('[data-tcd-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-act]'); if (!b) return;
      var li = b.closest('.tcd-item'), q = parseInt(li.querySelector('.tcd-qty span').textContent, 10);
      if (b.dataset.act === 'plus') change(li, q + 1);
      if (b.dataset.act === 'minus') change(li, Math.max(0, q - 1));
      if (b.dataset.act === 'rm') change(li, 0);
    });
    var go = root.querySelector('[data-tcd-checkout]');
    if (go) go.closest('form').addEventListener('submit', function () { go.disabled = true; go.querySelector('span').textContent = 'Redirection…'; });

    /* Ouvre le tiroir après un ajout (boutique, fiche produit) */
    document.addEventListener('cart:update', function (e) {
      document.querySelectorAll('.ts-toast,.tp-toast').forEach(function (t) { t.classList.remove('is-on'); t.style.display = 'none'; });
      (e.detail && e.detail.items ? show(e.detail) : refresh()).then(open, open);
    });
    /* Swipe vers le bas pour fermer sur mobile */
    var sy = null;
    panel.addEventListener('touchstart', function (e) { if (body.scrollTop <= 0) sy = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchmove', function (e) { if (sy == null) return; var d = e.touches[0].clientY - sy; if (d > 0 && window.innerWidth < 750) panel.style.transform = 'translateY(' + d + 'px)'; }, { passive: true });
    panel.addEventListener('touchend', function (e) { if (sy == null) return; var d = e.changedTouches[0].clientY - sy; panel.style.transform = ''; sy = null; if (d > 110 && window.innerWidth < 750) close(); });

    if (new URLSearchParams(location.search).get('panier') === '1') { refresh().then(open); }
    else if (parseInt(countEl.textContent, 10) > 0) { refresh(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
